import React from 'react';
import { Modal, Typography } from 'antd'; // Use Ant Design Title from Typography

const { Title } = Typography;

const SheetModal = ({ children, activeSheet, onClose }) => {
    return (
        <Modal
            open={!!activeSheet}
            maskClosable={false}
            className="custom-modal"
            title={
                <div className="custom-modal-header">
                    <Title
                        style={{
                            color: "white",
                            marginLeft: "15px",
                            position: "relative",
                            fontSize: "clamp(14px, 3vw, 20px)",
                            top: "-5px",
                            padding: "0px",
                        }}>
                        {activeSheet?.title || "Report Info"}
                    </Title>
                </div>
            }
            onCancel={onClose}
            footer={null}
            width={500}
        >
            <div
                style={{
                    maxHeight: "500px",
                    overflowX: "hidden",
                    overflowY: "auto",
                }}
            >
                {children}
            </div>
        </Modal>
    );
};


export default SheetModal